export const countryCallingCode = '966';
